module.exports = "automatic"